import { useTranslation } from 'react-i18next'
import NoTrackingPill from '~/pages/scorm/components/NoTrackingPill'

/** Le contenu du bandeau de prévisualisation : le module, et qu'il s'agit d'un aperçu. */
function PreviewHeader({ title }: { title?: string | null }) {
  const { t } = useTranslation()

  return (
    <>
      {title && <h1 className="truncate text-sm font-normal text-muted-foreground">{title}</h1>}
      <NoTrackingPill>{t('scorm.preview.badge')}</NoTrackingPill>
    </>
  )
}

export default PreviewHeader
